<template>
  <div class="modal-window ProjectManagewrap">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("title.paper.permission.assignment", "생성자 권한 이전") }}</div>
      <button @click="closePopup" class="btn_close">닫기</button>
    </header>

    <div class="modal-content dropdown-list member-search_box">
      <div class="tabPermission scroll_box" id="tabsTy1">
        <ul class="tab-menu">
          <dl class="my" v-for="(paperUserItem, paperUserIndex) in userList" :key="paperUserIndex"
            :value="userInfo.userId" v-show="paperUserItem.userId === userInfo.userId">
            <dt class="memberCnt">{{ $i18nUtil.trans("message.DashBoardHeader.027", "본인") }}</dt>
            <dd>
              <ul>
                <li>

                  <div class="myName">
                    {{ paperUserItem.userName }}
                    {{ paperUserItem.jobPositionName }}
                    <span style="width : 60px;" :class="{
                      'ico-creat':
                        paperUserItem.userId == paperInfo.regUserId
                          ? true
                          : false,
                    }">
                      {{
                        paperUserItem.userId == paperInfo.regUserId
                          ? $i18nUtil.trans('message.BoardContents.007', '보드 생성자')
                          : ""
                      }}
                    </span>
                  </div>
                  <div class="mail">
                    {{
                      paperUserItem.isExternalUser
                        ? paperUserItem.partnerName
                        : paperUserItem.deptName
                    }}
                  </div>

                </li>
              </ul>
            </dd>
          </dl>

        </ul>
        <div class="tab-content">
          <div class="member-list">

            <dl class="active memberCnt">
              {{$i18nUtil.trans('title.paper.permission.assignment.member','생성자 권한 이전 가능 멤버 목록')}}({{ memberCount(userList.length) }})
            </dl>
            <dl class="memberListline">
              <dd>
                <div class="nodata" v-if="userList.length == 0"
                  v-html="$i18nUtil.trans('message.DashBoardHeader.006', '멤버를 구성하여<br />협업해보세요.')">
                </div>
                <ul v-else>
                  <li v-for="(paperUserItem, paperUserIndex) in userList" :key="'member' + paperUserIndex" class="memberList">
                    <div class="droplayer relative" v-if="!(paperUserItem.userId === userInfo.userId)">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <button @click="confirmPermission(paperUserItem.userId, paperUserItem.userName)">{{
                            paperUserItem.userName
                          }}
                            {{ paperUserItem.jobPositionName }}
                            <span style="width : 100px;" :class="{
                              'ico-creat':
                                paperUserItem.userId ==
                                  paperInfo.regUserId
                                  ? true
                                  : false,
                            }">
                              {{
                                paperUserItem.userId == paperInfo.regUserId
                                  ? $i18nUtil.trans('message.BoardContents.007', '보드 생성자')
                                  : ""
                              }}
                            </span>
                          </button>
                        </template>
                        <div class="dropdown-list" v-if="isInternalUser">
                          <UserTooltip :userId="paperUserItem.userId" />
                        </div>
                      </v-menu>
                    </div>
                    <div class="mail" v-if="!(paperUserItem.userId === userInfo.userId)">
                      {{ paperUserItem.companyName }} /
                      {{
                          paperUserItem.isExternalUser
                            ? paperUserItem.partnerName
                            : paperUserItem.deptName
                      }}
                    </div>

                  </li>
                </ul>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import ProjectMemberManage from "../../project/modal/ProjectSetting";
export default {
  components: {
    ProjectMemberManage,
  },
  data() {
    return {
      currentTab1: 0,
      userList: [],
      userInfo: [],
      paperInfo: [],
      inherit:1,
      isInternalUser: false,
      docGrade: "",
      selectedUserId: "",
      selectedUserName: "",
      //tabsTy1: [this.$i18nUtil.trans("title.ProjectManage.001","과제 관리"), this.$i18nUtil.trans("title.ProjectFolderManage.001","과정 관리"), this.$i18nUtil.trans("title.ProjectMemberManage.001","멤버 관리")],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState("project", ["projectInfo"]),
  },
  created() {
    let body = document.querySelector("body");
    body.style.overflow = "hidden";
  },
  mounted() {
    this.userList = this.modalInfo.userList;
    this.userInfo = this.modalInfo.userInfo;
    this.paperInfo = this.modalInfo.paperInfo;
    this.inherit = this.modalInfo.inherit;
    this.isInternalUser = this.modalInfo.isInternalUser;
    this.docGrade = this.modalInfo.docGrade;
  },
  methods: {
     ...mapActions("modals", ["showModal", "showToast"]),
     ...mapMutations("project",["setPaperRegUser"]), 
     ...mapState("project", ["setPaperRegUser"]),
    closeModal() {
      this.$emit("close");
    },
    closePopup() {
      let body = document.querySelector("body");
      body.style.removeProperty("overflow");
      this.$emit("close");
    },
    memberCount(count) {
      let resultCount = count;
      this.userList.forEach((element) => {
        if (element.userId == this.userInfo.userId) {
          resultCount = count - 1;
        }
      });
      return resultCount;
    },
    permissionAssignment(){
      let url = "/api/copaper/paper/updatePaperConstructor";
      let param = {
        paperId: this.paperInfo.paperId,
        selectedUserId: this.selectedUserId,
        selectedUserName: this.selectedUserName,
        userId: this.userInfo.userId,
        userName: this.userInfo.userName,
        userNameEn: this.userInfo.userNameEn,
        assignmentInfo: this.$i18nUtil.trans("message.permission.assignment004",{userName:this.userInfo.userName, selectedUserName:this.selectedUserName}),
        //lockYn: paperLockYn,
      };
      let obj = this;
      this.showLoadingbar();
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("updatePaperConstructor error", res.data.errorCode);
          }else{
            this.$store.state.project.paperRegUser = this.selectedUserId;
            this.hideLoadingbar();
            this.closePopup();
            obj.toastInfo.message = obj.$i18nUtil.trans("message.permission.assignment002");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
          this.hideLoadingbar();
          this.closePopup();
          obj.toastInfo.message = obj.$i18nUtil.trans("message.permission.assignment003");
          obj.showToast(obj.toastInfo);
        });
    },
    confirmPermission(selectedUserId, selectedUserName) {
      this.selectedUserId = selectedUserId;
      this.selectedUserName = selectedUserName;
      let obj = this;
      obj.showConfirmDialogWithJSON({
        confirmMessage: obj.$i18nUtil.trans("message.permission.assignment001",{selectedUserName:selectedUserName}),
        confirmBtnText: obj.$i18nUtil.trans("button.confirm","확인"),
        confirmBtnCallback: obj.permissionAssignment,
        cancelBtnText : obj.$i18nUtil.trans("button.cancel","취소"),
      });
    },
  },
};
</script>
<style scoped>
.ProjectManagewrap {
  height: 400px;
}
.member-search_box {
  width: 100% !important;
  height: 100%;
  padding-bottom: 30px;
}
.myName, .droplayer {
  font-size: 18px;
  color: #000;
}
.memberListline{
  border-top: none;
}
.tit {
  font-size: 18px;
}
.tab-menu {
  border-bottom: 1px solid lightgray;
  padding-bottom: 10px;
}
.modal-window .tab-content {
    margin-top: 15px;
}
.ico-creat {
  display: inline-block;
    width: 40px;
    height: 17px;
    line-height: 17px;
    margin-left: 2px;
    font-family: 'LifeplusM';
    font-size: 11px;
    color: #fff;
    text-align: center;
    border-radius: 8.5px;
    background-color: black;
}
.memberList {
  margin-bottom: 8px;
}
.mail {
  font-size: 15px;
}
.memberCnt {
  font-size: 15px;
  margin-bottom: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/PaperPermissionModal.vue